import React from "react";
import Card from "../../Materials/Card";
import FetchBlog from "./FetchBlog.js";
import classes from "../../../styles/Blog.module.css";
import { Link, Navigate, NavLink } from "react-router-dom";
import cls from "../../../styles/NavBar.module.css";
import CreateBlog from "../Create/CreateBlog";

const DummyPara = [
  {
    id: "p1",
    title: "I am Consistent towards my goals",
    para: "I will do against my pleasure points doesnt exist in my goals",
  },
  {
    id: "p2",
    title: "I will make today the best ever day of my life",
    para: "I will make today the best ever day of my life by doing what I love and need to do for my goals ",
  },
  {
    id: "p3",
    title: "I will make today the best ever day of my life",
    para: "I will make today the best ever day of my life by doing what I love and need to do for my goals ",
  },
];

const Blog = () => {
  const [para, setPara] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  const fetchParaHandler = async () => {
    setIsLoading(true);
    const res = await fetch(
      "https://overvalue-8fc05-default-rtdb.firebaseio.com/nexula.json"
    );
    if (!res.ok) {
      return res.json().then((data) => {
        if (data || data.error || data.error.message) {
          alert(data.error.message);
          throw new Error(data.error.message);
        }
      });
    }
    setIsLoading(false);
    const data = await res.json();
    const transformPara = [];
    for (const key in data) {
      transformPara.push({
        id: data[key].id,
        title: data[key].title,
        para: data[key].para,
      });
    }

    setPara(transformPara);
  };
  React.useEffect(() => {
    fetchParaHandler();
  }, []);

  if (!para || para.length === 0) {
    return (
      <>
        <p style={{ fontSize: "1rem", width: "100%" }}>
          Oops! No blog found <h2>:(</h2>
        </p>
        <button>
          <NavLink to="/createblog">Create Blog</NavLink>
        </button>
      </>
    );
  }

  return (
    <div className={classes.container}>
      <button onClick={fetchParaHandler}>
        {isLoading ? "Loading..." : "Fetch Para"}
      </button>
      <FetchBlog fetchPara={para} />
    </div>
  );
};

export default Blog;
